import {Record} from 'immutable';

export const TeamCoachingActivity = Record({
  id: null,
  name: null,

  callsListenedToMax: null,
  callsListenedToAvg: null,

  totalTimeListenedAvg: null,
  totalTimeListenedMax: null,

  avgEachCallListenedToMax: null,
  avgEachCallListenedToAvg: null,

  commentsCreatedMax: null,
  commentsCreatedAvg: null,

  commentLengthMax: null,
  commentLengthAvg: null,

  highlightsCreatedAvg: null,
  highlightsCreatedMax: null,

  callsAddedToLibrariesMax: null,
  callsAddedToLibrariesAvg: null,

  scoreCardsCompletedMax: null,
  scoreCardsCompletedAvg: null,
});

const RepProfileCoachingActivity = Record({
  callsListenedTo: null,
  avgEachCallListenedTo: null,
  totalTimeListened: null,
  commentsCreated: null,
  commentLength: null,
  highlightsCreated: null,
  callsAddedToLibraries: null,
  scoreCardsCompleted: null,
});
export default RepProfileCoachingActivity;
